// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__Y366V","checkboxCol":"Table_checkboxCol__11sCm","emailCol":"Table_emailCol__CnSxy","actionCol":"Table_actionCol__3ja_e"};